module.exports = __webpack_public_path__ + "img/04.9d263484.png";